// src/services/Config.js
import axios from "axios";

const API = axios.create({
  baseURL: "/api",  // o "/api" si usas proxy CRA
  // cualquier otra configuración global…
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("tokenTipoP");
  if (token && config.headers) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

export default API;
